import { Component, ElementRef, TemplateRef, ViewChild, Input, Inject } from '@angular/core';

import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';

import { CDSMask } from '@app/utils/cds-mask';
import { IdDescricao } from '@app/models/util/id-descricao';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-fluxo-de-caixa-diario-real',
  templateUrl: './fluxo-de-caixa-diario-real.component.html'
})
export class FluxoDeCaixaDiarioRealComponent {
  @ViewChild('relatorio') relatoriosElemento: ElementRef;
  rel: any;
  relResumo: any;
  cdsMask: CDSMask = new CDSMask();
  filtros: any;
  modalRef: BsModalRef;
  resumoDia: any;
  @Input() lstUnidades: IdDescricao[] = [];
  @Input() lstConta: IdDescricao[] = [];
  pesquisando: boolean;
  showTable: boolean;

  dataRelatorio: Date;

  constructor(
    private modalService: BsModalService,
    private relatorioService: RelatorioService,
    @Inject(ToastrService) public toastr: ToastrService
  ) {
    this.filtros = {
      ContaId: null,
      UnidadeId: '',
      DataInicial: UtilitarioService.retornaDataAtualMaisDiasISO(0),
      DataFinal: UtilitarioService.retornaDataAtualMaisDiasISO(0),
    };

  }

  pesquisar() {
    this.dataRelatorio = new Date();
    this.pesquisando = true;
    this.relatorioService.fluxoDeCaixaDiario(this.filtros).toPromise()
      .then(relatorio => {
        this.rel = relatorio;
        this.pesquisando = false;

        if (this.rel.Itens.length > 0) {
          this.showTable = true;
        } else {
          this.showTable = false;
          this.toastr.info('Busca não encontrou resultados');
        }
      }, erro => {
        this.pesquisando = false;
        this.toastr.warning('Realize a pesquisa novamente.');
      });
    //  () => this.pesquisando = false);
  }

  public imprimir() {
    let conteudo = document.getElementById("fluxoDeCaixaReal").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, 'Relatório Fluxo de Caixa Diário', this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());

    parseDateAdicionaMap('Data Inicial', this.filtros.DataInicial);
    parseDateAdicionaMap('Data Final', this.filtros.DataFinal);

    obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.filtros.UnidadeId);
    obtemDescricaoAdicionaMap('Conta', this.lstConta, this.filtros.ContaId);

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      }
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

  resumo(template: TemplateRef<any>, data: any) {
    this.resumoDia = data;

    const filtros = { ...this.filtros };
    filtros.DataInicial = data;
    this.relatorioService.fluxoDeCaixaDiarioResumo(filtros).toPromise().then(dados => {
      this.relResumo = dados;
      this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-xl' });
    });
  }
}
